module.exports = __webpack_public_path__ + "img/relation1.334ebfb9.png";